const taskGroupEnum = {
    MEDICINE: 1,
    DOCUMENT: 2,
    OTHER: 999
}

export default taskGroupEnum;